import React from 'react'
import CodeBlock from '../Code';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
const OcrEx = () => {
    
    return (
        <div id="group03" class="cont-group">
        <div class="group-header">
          <h4 class="mb-4b mx-3">구현예제</h4>
        </div>
        <div class="row">
          <div className='col-12 mx-3'>
          <Tabs>
              <TabList>
                <Tab>Python</Tab>
                <Tab>Java</Tab>
                <Tab>Node.js</Tab>
              </TabList>
         
            <TabPanel>
            <div role="tabpanel" class="tab-pane active" id="tab01-03">
              <div class="title"><h5 class="mb-4">Python</h5></div>											
              <div class="divcode">
                  <CodeBlock
                      code={`                      
                      # coding:utg-8
                      import urllib3
                      import json
                      import base64
                      openApiURL = "/ocr/predict"
                      accessKey = "YOUR_ACCESS_KEY"
                      imageFilePath = "IMAGE_FILE_PATH"
                      file = open(imageFilePath, "rb")
                      imageContents = base64.b64encode(file.read()).decode("utf8")
                      file.close()
                      requestJson = {
                              "image": imageContents,
                              "return_img" : True,
                      }
                      
                      http = urllib3.PoolManager()
                      response = http.request(
                              "POST",
                              openApiURL,
                              headers={
                                      "Content-Type": "application/json; charset=UTF-8",
                                      "x-ncp-apigw-api-key": accessKey,
                              },
                              body=json.dumps(requestJson)
                      )
                      
                      data = json.loads(response.data)
                      print("[responseCode] " + str(response.status))
                      print("[responBody]")
                      print(data)
                      
                      if(data['image'] is not None):
                              with open("responsedImg.png", "wb") as fh:
                                      fh.write(base64.b64decode(data['image']))
                              print('Image Saved')`}
                  ></CodeBlock>

                  </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div role="tabpanel" class="tab-pane" id="tab01-01">
                <div class="title"><h5 class="mb-4">Java</h5></div>											
                <div class="divcode">
                <CodeBlock
                code={`
                import java.io.DataOutputStream;
                import java.io.IOException;
                import java.io.InputStream;
                import java.net.HttpURLConnection;
                import java.net.MalformedURLException;
                import java.net.URL;
                import java.util.HashMap;
                import java.util.Map;
                import java.nio.file.Files;
                import java.nio.file.Path;
                import java.nio.file.Paths;
                import java.util.Base64;
                
                import com.google.gson.Gson;
                
                public class Test {
                
                        static public void main ( String[] args ) {
                                String openApiURL = "/ocr/predict";
                                String accessKey = "YOUR_ACCESS_KEY";    // 발급받은 API Key
                                String file = "IMAGE_FILE_PATH";    // 이미지 파일 경로
                                String imageContents = "";
                                Gson gson = new Gson();
                
                                Map<string, object=""> request = new HashMap<>();
                
                                try {
                                        Path path = Paths.get(file);
                                        byte[] imageBytes = Files.readAllBytes(path);
                                        imageContents = Base64.getEncoder().encodeToString(imageBytes);
                                } catch (IOException e) {
                                        e.printStackTrace();
                                }
                
                                request.put("image", imageContents);
                                request.put("return_img", false);
                
                                URL url;
                                Integer responseCode = null;
                                String responBody = null;
                                try {
                                        url = new URL(openApiURL);
                                        HttpURLConnection con = (HttpURLConnection)url.openConnection();
                                        con.setRequestMethod("POST");
                                        con.setDoOutput(true);
                                        con.setRequestProperty("x-ncp-apigw-api-key", accessKey);
                                        con.setRequestProperty("Content-Type", "application/json; charset=UTF-8");
                
                                        DataOutputStream wr = new DataOutputStream(con.getOutputStream());
                                        wr.write(gson.toJson(request).getBytes("UTF-8"));
                                        wr.flush();
                                        wr.close();
                
                                        responseCode = con.getResponseCode();
                                        InputStream is = con.getInputStream();
                                        byte[] buffer = new byte[is.available()];
                                        int byteRead = is.read(buffer);
                                        responBody = new String(buffer);
                                        System.out.println("[responseCode] " + responseCode);
                                        System.out.println("[responBody]");
                                        System.out.println(responBody);
                
                                } catch (MalformedURLException e) {
                                        e.printStackTrace();
                                } catch (IOException e) {
                                        e.printStackTrace();
                                }
                        }
                }
                `}>


                  </CodeBlock>
                  </div>
              </div>	
            </TabPanel>
            <TabPanel>
              <div class="title"><h5 class="mb-4">Node.js</h5></div>											
              <div class="divcode">
                  <CodeBlock
                  code={`
                  var fs = require('fs');
                  var request = require('request');
                    
                  var openApiURL = '/ocr/predict';
                  var accessKey = 'YOUR_ACCESS_KEY';
                  var imageFilePath = 'IMAGE_FILE_PATH';
                  var imageData;
                      
                  var imageData = fs.readFileSync(imageFilePath);
                      
                  var requestJson = {
                                  'image': imageData.toString('base64'),
                                  'return_img': false,
                  };
                      
                  var options = {
                                  url: openApiURL,
                                  body: JSON.stringify(requestJson),
                                  headers: {
                                                  'Content-Type':'application/json; charset=UTF-8',
                                                  'x-ncp-apigw-api-key':accessKey,
                                  }
                  };
                  request.post(options, function (error, response, body) {
                                  console.log('responseCode = ' + response.statusCode);
                                  console.log('responseBody = ' + body);
                  });`}>

                  </CodeBlock>
              </div>
            </TabPanel>
            </Tabs>   
          </div>
            
            </div>
        </div>	
    )
}
export default OcrEx;